import { getClaimsClientsForActiveSubscription } from 'app/modules/claim/service';
import { getDocCMS } from 'app/modules/cms/service/cmsService';
import { getContactEngineSelector } from 'app/modules/cms/service/store/selectors';
import { createContact, resetContact } from 'app/modules/contact/service';
import { getActiveSubscriptionByClient } from 'app/modules/contract/service';
import { getSubscriptionsList } from 'app/modules/contract/service/store/selectors';
import { DeviceType } from 'app/modules/rules/domain/Device.type';
import { RulesKeys } from 'app/modules/rules/domain/rules.keys';
import { RulesContext } from 'app/modules/rules/domain/RulesContext';
import { View } from 'app/modules/rules/domain/View';
import { getDataView } from 'app/modules/rules/service/rulesService';
import { getDataViewRules } from 'app/modules/rules/service/store/selectors';
import ConfComp from 'app/shared/components/common/conf-component';
import { IRootState } from 'app/shared/reducers';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useRouteMatch } from 'react-router-dom';
import './contact.scss';

const ContactEngine = () => {
  const dispatch = useDispatch();
  const match: any = useRouteMatch();
  const subscriptionSelected = useSelector<IRootState>(state => state.contract.subscriptionModel.subscriptionSelected) as any;
  const claimSelected = useSelector<IRootState>(state => state.claim.claimModel) as any;
  const claimContactCms: any = useSelector(getContactEngineSelector);
  const viewConf = useSelector(getDataViewRules(View.CONTACT_PAGE));
  const { params } = match;
  const subscriptionList: any = useSelector(getSubscriptionsList);
  const claimList: any = useSelector<IRootState>(state => state.claim.claimsList);
  const loadingCms: any = useSelector<IRootState>(state => state.cms.loading);
  const loading: any = useSelector<IRootState>(state => state.claim.loading);

  const rulesContext: RulesContext = {
    key: RulesKeys.GET_VIEW_DATA_CONFIGURATION,
    entryDataRules: { view: View.CONTACT_PAGE, deviceType: DeviceType.MOBILE },
  };
  const location = useLocation();

  const locationState: any = location.state || '';
  const handleCreateContact = (data: any) => {
    dispatch(createContact(data));
  };
  const restContact = () => dispatch(resetContact());
  useEffect(() => {
    dispatch(getDataView(rulesContext));
  }, []);

  useEffect(() => {
    if (viewConf?.dataRecoveryService?.find(service => service === 'GetActiveSubscriptionList'))
      dispatch(getActiveSubscriptionByClient());
    if (viewConf?.dataRecoveryService?.find(service => service === 'GetClaimsClientsForActiveSubscription'))
      dispatch(getClaimsClientsForActiveSubscription());
    if (viewConf?.dataRecoveryService?.find(service => service === 'MobileContactEnignePage'))
      dispatch(getDocCMS('mobile_contact_engine_v2'));
  }, [viewConf]);

  const contactUsedData =
    locationState.motif === 'SUBSCRIPTION'
      ? {
        motif: 'SUBSCRIPTION',
        subscriptionNumber: subscriptionSelected?.number,
        clientNumber: subscriptionSelected?.subscriber?.number,
      }
      : {
        motif: 'CLAIM',
        claimNumber: claimSelected?.claim?.claimNumber,
        subscriptionNumber: claimSelected?.subscription?.number,
        clientNumber: claimSelected?.subscription?.subscriber?.number,
      };

  return (
    <>
      {viewConf && (
        <ConfComp
          code={'MOBILE_CONTACT_CHOICE'}
          listCode={viewConf.componentDataList}
          props={{ contactUsedData, loading, locationState, handleCreateContact, claimContactCms, subscriptionList, claimList, loadingCms, params,restContact }}
        />
      )}
    </>
  );
};

export default ContactEngine;
